import React, { useState } from "react";

import UseAuthConfig from "../../../hooks/useAuthConfig";

const useReqRequests = () => {
  const { protectedResources }: any = UseAuthConfig();
  const [reqRequests, setReqRequest] = useState({
    PageNumber: 1,
    SearchText: "",
    SortOrder: 1,
    PageSize: 10,
    OrderBy: "",
    ParameterOne: "Requested,Rejected",
    ParameterTwo: "",
    ParameterThree: "Requested,Rejected",
    url: protectedResources.apiTodoList.endpoint,
    accessToken: localStorage.getItem("AccessToken") || "llll",
  });

  const updateReqRequests = (newData: any) => {
    setReqRequest((prevData) => ({ ...prevData, ...newData }));
  };

  return { reqRequests, updateReqRequests };
};

export default useReqRequests;
